import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { cookingStoryPageRecipe } from 'src/app/core/model/api-response/cooking-story-model';
import { CookingStoryApiService } from 'src/app/data/repository/cooking-story/cooking-story-api.service';
import { RecipeService } from 'src/app/data/repository/recipe-repository/recipe.service';

@Component({
  selector: 'app-cooking-story-show-more',
  templateUrl: './cooking-story-show-more.component.html',
  styleUrls: ['./cooking-story-show-more.component.scss'],
})
export class CookingStoryShowMoreComponent implements OnInit {
  categorieId: string;
  type: string;
  title: string;
  public shadowNav: boolean = false;
  ready: boolean = false;
  public rightColumn: cookingStoryPageRecipe[] = [];
  public leftCoulumn: cookingStoryPageRecipe[] = [];

  col: number;
  row: number;
  gap: number;
  page: number = 0;
  sending: boolean = false;
  count: number;
  @ViewChild('scroolEl') scroolEl: ElementRef<HTMLDivElement>;

  constructor(
    private cookingStoryApiService: CookingStoryApiService,
    private recipeService: RecipeService,

    private route: ActivatedRoute
  ) {
    this.categorieId = this.route.snapshot.paramMap.get('categoryId');
    this.type = this.route.snapshot.paramMap.get('type');
    this.title = this.route.snapshot.paramMap.get('title');

    this.getPagePost(this.categorieId, this.page);
    this.col = (window.innerWidth - 48 - 24) / 2;
    this.row = this.col / 3 + 24;
    this.gap = this.row / 4;
  }
  devide(data: cookingStoryPageRecipe[]) {
    this.leftCoulumn.push(...data.filter((v, i) => i % 2 == 0));
    this.rightColumn.push(...data.filter((v, i) => i % 2 != 0));
  }

  public goBak() {
    this.recipeService.back();
  }
  public getPagePost(id: string, page: number) {
    this.sending = true;
    this.cookingStoryApiService
      .getCokkingStoryMorePost(this.categorieId, this.type, page)
      .then((res) => {
        this.devide(res.getData().getCookingStoryMorePost().recipes);
        this.count = res.getData().getCookingStoryMorePost().count;
        this.sending = false;
        this.ready = true;
      });
  }
  garr(length: number) {
    return new Array(length);
  }

  scrolling(data) {
    let suggestEl = this.scroolEl.nativeElement;

    if (suggestEl.scrollTop >= 90) {
      this.shadowNav = true;
    } else {
      this.shadowNav = false;
    }
    if (
      suggestEl.scrollTop + suggestEl.clientHeight >=
      suggestEl.scrollHeight - 100
    ) {
      if (
        !this.sending &&
        this.count &&
        this.count > this.rightColumn.length + this.leftCoulumn.length
      ) {
        this.page += 1;
        this.getPagePost(this.categorieId, this.page);
      }
    }
  }
  openRecipe(recipeId) {
    this.recipeService.goToRecipeDetail(recipeId);
  }
  ngOnInit(): void {}
}
